import { Http } from '../../../support';

const initialState = {
  data: {},
  busy: false,
  error: undefined,
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.admin.clientes.info = {
      ...state.admin.clientes.info,
      ...data,
    };
  });
};

const info = async (store, id, params = {}) => {
  store.setState((state) => {
    state.admin.clientes.info.busy = true;
  });

  const paramsRequest = {
    ...params,
    include: 'config,servicios,metadata',
  };

  try {
    const response = await Http.get(`api/clientes/${id}`, { params: paramsRequest });

    store.setState((state) => {
      state.admin.clientes.info = {
        ...state.admin.clientes.info,
        data: response.data,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.clientes.info.error = error.data || error;
    });
  } finally {
    store.setState((state) => {
      state.admin.clientes.info.busy = false;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.admin.clientes.info = { ...initialState };
  });
};

const ClienteInfoStore = {
  state: () => initialState,
  actions: {
    info,
    reset,
    setPartialState,
  },
};

export default ClienteInfoStore;
